{
  "mar": {
    "title": "给药记录",
    "loading": "正在加载给药记录...",
    "emptyState": "此患者无活跃用药医嘱",
    "loadError": "加载药物失败",
    "retry": "重试",
    "previousDay": "前一天",
    "nextDay": "后一天",
    "view24h": "24h",
    "view12h": "12h",
    "viewShift": "班次",
    "dayShiftHeader": "白班（07:00 - 19:00）",
    "nightShiftHeader": "夜班（19:00 - 07:00）",
    "newOrder": "新增用药医嘱",
    "printMar": "打印给药记录",
    "prnSection": "必要时（PRN）用药",
    "filter": {
      "timeWindow": "时间窗",
      "category": "类别",
      "status": "状态",
      "scheduledOnly": "仅显示按时给药"
    },
    "adminStatus": {
      "scheduled": "已排定",
      "dueNow": "到时",
      "overdue": "逾期",
      "administered": "已给药",
      "held": "暂停",
      "refused": "拒绝",
      "missed": "漏给"
    },
    "columns": {
      "medication": "药品",
      "drug": "药品",
      "doseRoute": "剂量 / 途径",
      "schedule": "排程",
      "scheduledTime": "排定时间",
      "givenTime": "给药时间",
      "givenBy": "给药人",
      "status": "状态"
    },
    "actions": {
      "administer": "给药",
      "hold": "暂停",
      "refuse": "拒绝",
      "skip": "跳过",
      "missed": "标记漏给",
      "edit": "编辑给药",
      "viewHistory": "查看历史",
      "givePrn": "PRN 给药"
    },
    "prn": {
      "badge": "PRN",
      "highAlertBadge": "高警示药物",
      "indication": "适应证：{{indication}}",
      "lastGiven": "上次给药：{{time}}",
      "lastGivenBy": "上次给药：{{time}}（{{user}}）"
    },
    "orderBadge": {
      "active": "进行中",
      "onHold": "暂停中",
      "discontinued": "已停用"
    },
    "legend": "图例：",
    "summary": {
      "medsGivenToday": "今日给药：",
      "ofTotal": "{{given}} / {{total}}",
      "overdueCount_one": "逾期 {{count}} 项",
      "overdueCount_other": "逾期 {{count}} 项",
      "nextDue": "下次给药：",
      "nextDueAt": "{{medName}}，{{time}}"
    },
    "tooltip": {
      "given": "（已给药 {{time}}）",
      "pending": "正在记录… 服务器尚未确认"
    },
    "doseModal": {
      "title": "给药",
      "doseGiven": "实际给药剂量",
      "siteOfAdministration": "给药部位",
      "comments": "备注",
      "vitalsCheck": "给药前生命体征核查",
      "doubleCheck": "双人核对",
      "verifier": "核对人",
      "confirm": "确认给药"
    },
    "administerDialog": {
      "doseLabel": "剂量",
      "routeLabel": "给药途径",
      "siteLabel": "给药部位（如适用）",
      "site": {
        "notApplicable": "不适用",
        "leftArm": "左臂",
        "rightArm": "右臂",
        "leftDeltoid": "左三角肌",
        "rightDeltoid": "右三角肌",
        "leftGluteal": "左臀",
        "rightGluteal": "右臀",
        "leftThigh": "左大腿",
        "rightThigh": "右大腿",
        "abdomen": "腹部"
      },
      "timeAdministered": "给药时间",
      "administeredDateAria": "给药日期",
      "administeredTimeAria": "给药时刻",
      "notesLabel": "备注",
      "notesPlaceholder": "可选备注..."
    },
    "prnWarning": {
      "title": "PRN 间隔时间警告",
      "lastDoseHoursAgo": "上次给药距今 {{hours}} 小时。",
      "minimumInterval": "最短间隔为 {{hours}} 小时。",
      "lastAdministered": "上次给药：{{time}}",
      "justificationLabel": "提前给药理由",
      "justificationRequired": "*",
      "justificationPlaceholder": "请填写早于最短间隔给药的临床理由...",
      "cancel": "取消",
      "overrideContinue": "覆盖并继续"
    },
    "toast": {
      "administered": "已记录给药",
      "administerError": "记录给药失败",
      "administerNotImplemented": "MAR 给药记录功能尚未启用",
      "held": "已暂停给药",
      "refused": "已记录患者拒绝",
      "skipped": "已跳过此次给药",
      "orderNotActive": "此医嘱已不再有效（已停用、取消或完成），无法执行给药。"
    },
    "holdRefuseDialog": {
      "holdTitle": "暂停给药",
      "refuseTitle": "拒绝给药",
      "skipTitle": "跳过给药",
      "scheduledLabel": "排定：{{time}}",
      "holdReasonLabel": "暂停原因",
      "refusalNotesLabel": "拒绝记录",
      "skipReasonLabel": "跳过原因",
      "holdReasonPlaceholder": "请填写暂停原因...",
      "refusalPlaceholder": "记录患者拒绝情况...",
      "skipPlaceholder": "请填写跳过原因...",
      "cancel": "取消",
      "confirm": "确认"
    },
    "contextMenu": {
      "hold": "暂停",
      "refuse": "拒绝",
      "skip": "跳过"
    },
    "holdReason": {
      "label": "暂停原因",
      "options": {
        "patientNpo": "患者 NPO（禁食）",
        "vitalsOutOfRange": "生命体征超出范围",
        "patientRefused": "患者拒绝",
        "providerOrder": "医师下令暂停",
        "other": "其他"
      }
    },
    "give": {
      "title": "给药 · {{medication}} {{dose}}",
      "scheduledLabel": "排定 {{time}}",
      "patientLabel": "患者",
      "patientLine": "{{name}} · {{mrn}}",
      "patientLineIdOnly": "患者ID：{{id}}",
      "medicationLabel": "药品",
      "scanPatientPlaceholder": "扫描腕带",
      "scanPatientAria": "扫描患者腕带",
      "scanMedicationPlaceholder": "扫描药品包装条码",
      "scanMedicationAria": "扫描药品包装",
      "patientMismatch": "此腕带不属于该患者。请勿给药。",
      "medicationMismatch": "此包装不是医嘱药品。请勿给药。",
      "notScannable": "无法扫码核对 — 此医嘱未登记条码",
      "overrideReason": "未扫码即给药的理由",
      "overrideReasonPlaceholder": "例如：腕带破损；无条码的配制剂量",
      "pharmacyOverride": "药剂科尚未审核此高警示药品",
      "pharmacyOverridePlaceholder": "此次给药为何不能等待药剂科审核？",
      "timeLabel": "时间",
      "detailsEdit": "编辑",
      "detailsDone": "完成",
      "confirmLabel": "以上信息与医嘱及手中药品一致",
      "cancel": "取消",
      "submit": "给药",
      "witness": {
        "banner": "高警示药品 — 需第二名护士核对",
        "usernameLabel": "第二名护士用户名",
        "passwordLabel": "密码",
        "verify": "核对",
        "verifying": "正在核对…",
        "verified": "已由第二名护士核对",
        "rejected": "无法识别该凭据。",
        "overrideLabel": "无法核对？未经第二名护士核对即给药 — 理由",
        "overridePlaceholder": "此次给药为何不能等待独立双人核对？"
      },
      "refusal": {
        "wrongPatient": "患者不符 — 扫描的腕带与此医嘱不匹配。请勿给药。",
        "wrongMedication": "药品不符 — 扫描的包装与医嘱药品不匹配。请勿给药。",
        "scanRequired": "请扫描腕带和药品，或填写未扫码的理由。",
        "pharmacyVerificationRequired": "药剂科尚未审核此医嘱。请等待审核，或记录无法等待的理由。",
        "doubleCheckRequired": "尚无第二名护士对此医嘱进行双人核对。请安排核对，或记录无法等待的理由。",
        "doubleCheckSelf": "不能由本人核对自己的给药。须由第二名护士核对。"
      },
      "dispense": {
        "handedOver": "{{quantity}} 已于 {{time}} 交付",
        "label": "药房发药",
        "none": "此医嘱暂无发药记录",
        "pending": "已记录发药，尚未交付",
        "prepared": "{{quantity}} 已于 {{time}} 配置",
        "unavailable": "无法查询发药情况——未能读取记录"
      }
    }
  },
  "status": {
    "active": "进行中",
    "held": "暂停",
    "discontinued": "停用",
    "completed": "已完成",
    "refused": "拒绝",
    "missed": "漏给",
    "given": "已给药"
  },
  "route": {
    "po": "口服",
    "iv": "静脉注射",
    "im": "肌内注射",
    "sc": "皮下注射",
    "in": "鼻腔",
    "pr": "直肠",
    "sl": "舌下",
    "top": "外用",
    "neb": "雾化吸入",
    "pv": "阴道",
    "ng": "鼻胃管",
    "ophthalmic": "眼用",
    "transdermal": "透皮"
  },
  "frequency": {
    "bid": "每日两次",
    "tid": "每日三次",
    "qid": "每日四次",
    "qd": "每日一次",
    "qhs": "睡前",
    "prn": "必要时（PRN）",
    "stat": "立即（STAT）",
    "continuous": "持续给药"
  },
  "formulary": {
    "title": "药品处方集",
    "searchPlaceholder": "按药品名、通用名或代码搜索...",
    "clearSearch": "清除搜索",
    "category": {
      "all": "全部",
      "analgesic": "镇痛类",
      "antibiotic": "抗生素",
      "antifungal": "抗真菌药",
      "antiviral": "抗病毒药",
      "cardiac": "心血管类",
      "endocrine": "内分泌类",
      "gi": "消化道类",
      "neurological": "神经系统类",
      "psychiatric": "精神类",
      "respiratory": "呼吸系统类",
      "other": "其他"
    },
    "columns": {
      "medication": "药品",
      "genericName": "通用名",
      "form": "剂型",
      "strength": "规格",
      "route": "给药途径",
      "status": "状态",
      "schedule": "管制等级"
    },
    "highAlertBadge": "高警示药品",
    "highAlertTag": "高警示",
    "status": {
      "preferred": "首选",
      "restricted": "限制使用",
      "nonFormulary": "非处方集"
    },
    "loading": "正在加载处方集...",
    "loadError": "无法加载处方集",
    "empty": "未找到药品。",
    "pagination": {
      "showing": "显示 {{from}}-{{to}}（共 {{total}} 条）",
      "page": "第 {{page}} 页，共 {{totalPages}} 页",
      "previous": "上一页",
      "next": "下一页"
    },
    "details": {
      "close": "关闭详情",
      "genericName": "通用名",
      "category": "类别",
      "formStrength": "剂型 / 规格",
      "route": "给药途径",
      "formularyStatus": "处方集状态",
      "deaSchedule": "DEA 管制等级",
      "indications": "适应证",
      "contraindications": "禁忌证",
      "interactions": "药物相互作用",
      "sideEffects": "不良反应",
      "dosageGuidelines": "用法用量",
      "specialPopulations": "特殊人群",
      "storage": "贮存"
    }
  },
  "worklist": {
    "title": "Medication Worklist",
    "subtitle": "Active medications for the patients in your care",
    "summary": "{{medications}} medications across {{patients}} patients",
    "refresh": "Refresh",
    "searchPlaceholder": "Search by patient name, MRN, or medication...",
    "openMar": "Open MAR",
    "loadError": "Failed to load the medication worklist",
    "retry": "Retry",
    "priority": {
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Routine",
      "scheduled": "Scheduled"
    },
    "empty": {
      "title": "Nothing to administer",
      "description": "No active medications for your patients."
    },
    "columns": {
      "medication": "Medication",
      "dose": "Dose",
      "route": "Route",
      "frequency": "Frequency",
      "priority": "Priority"
    },
    "row": {
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "unknownPatient": "Unknown patient",
      "medCount_one": "{{count}} active medication",
      "medCount_other": "{{count}} active medications",
      "controlled": "Controlled {{schedule}}"
    }
  },
  "pharmacist": {
    "title": "药师审核队列",
    "subtitle": "审核并核对待处理的医嘱",
    "pendingCount": "待审核 {{count}} 条",
    "refresh": "刷新",
    "searchPlaceholder": "按药品、患者姓名或 MRN 搜索...",
    "priority": {
      "all": "全部优先级",
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "常规",
      "scheduled": "预定"
    },
    "loadError": "无法加载医嘱队列",
    "retry": "重试",
    "empty": {
      "title": "已全部处理完毕",
      "description": "没有待审核的医嘱。"
    },
    "columns": {
      "patient": "患者",
      "medication": "药品",
      "doseRouteFreq": "剂量 / 途径 / 频次",
      "priority": "优先级",
      "orderingProvider": "开嘱医师",
      "ordered": "开嘱时间",
      "actions": "操作"
    },
    "row": {
      "unknown": "未知",
      "mrnLabel": "MRN：{{mrn}}",
      "mrnUnknown": "---",
      "controlled": "管制药 {{schedule}}",
      "providerFallback": "医师 #{{id}}",
      "providerUnknown": "---"
    },
    "actions": {
      "verify": "核对",
      "verifyTooltip": "核对此医嘱",
      "reject": "驳回",
      "rejectTooltip": "驳回并停用",
      "confirmReject": "确认",
      "cancelReject": "取消",
      "rejectReasonPlaceholder": "驳回原因..."
    },
    "toast": {
      "verifySuccess": "医嘱 #{{id}} 已核对",
      "verifyError": "核对医嘱失败",
      "rejectSuccess": "医嘱 #{{id}} 已驳回并停用",
      "rejectError": "驳回医嘱失败",
      "rejectReasonRequired": "请填写驳回原因",
      "notIndependent": "开具医嘱者不能核对自己的医嘱。",
      "overrideSuccess": "医嘱 {{id}} 已在未经药师核对的情况下生效",
      "overrideError": "无法记录越权",
      "overrideReasonRequired": "越权需同时填写原因代码和理由"
    },
    "verifyDialog": {
      "title": "核对用药医嘱",
      "instruction": "请确认已完成的每一项检查。四项均为必填——部分复核不构成核对。",
      "checks": {
        "allergy": "我已对照患者过敏史复核此医嘱",
        "interaction": "我已复核药物相互作用",
        "duplicateTherapy": "我已复核重复用药",
        "doseRange": "我已复核该患者的剂量"
      },
      "cancel": "取消",
      "confirm": "核对医嘱"
    },
    "override": {
      "action": "越权放行",
      "confirm": "记录越权",
      "cancel": "取消",
      "tooltip": "在未经药师核对的情况下继续。会记录原因；不满足高警示药品的药房核查。",
      "codeLabel": "越权原因代码",
      "codePlaceholder": "请选择原因…",
      "justificationLabel": "越权理由",
      "justificationPlaceholder": "为何在未经药房复核的情况下继续？",
      "code": {
        "pharmacyClosed": "药房已关闭",
        "urgentClinicalNeed": "紧急临床需要",
        "pharmacyUnreachable": "无法联系药房"
      }
    },
    "clarify": {
      "action": "澄清",
      "tooltip": "药房对该医嘱的编码与原处方不同。须先处理才能给药。",
      "heading": "药房编码与原处方不同",
      "holding": "（暂停该医嘱）",
      "upheld": "维持原医嘱",
      "upheldTooltip": "原医嘱正确，按原样调配。",
      "amended": "我已修改",
      "amendedTooltip": "记录该医嘱已被修改。",
      "adopt": "采纳药房版本",
      "adoptTooltip": "依据协作执业协议或药事管理与药物治疗学委员会方案接受编码版本。",
      "close": "关闭",
      "toast": {
        "resolved": "澄清已处理；医嘱返回待核对",
        "error": "无法处理该澄清"
      }
    }
  },
  "reconciliation": {
    "title": "用药核对",
    "subtitle": "{{patient}} | {{mrn}} | 就诊 #{{encounter}}",
    "complete": "完成核对",
    "loading": "正在加载用药记录...",
    "column": {
      "home": "院前用药",
      "inpatient": "住院用药",
      "discharge": "出院用药"
    },
    "emptyHome": "未找到院前用药。",
    "emptyInpatient": "未找到住院用药。",
    "emptyDischarge": "尚无出院用药。请在其他列中选择继续或修改用药。",
    "changedFromHome": "与院前用药相比有变更",
    "action": {
      "continue": "继续",
      "modify": "修改",
      "discontinue": "停用",
      "discontinueShort": "D/C",
      "newOrder": "新增"
    },
    "addToDischarge": "加入出院用药",
    "remove": "移除",
    "modifyForm": {
      "title": "修改用药",
      "dose": "剂量",
      "route": "给药途径",
      "frequency": "频次",
      "dosePlaceholder": "例如：500mg",
      "routePlaceholder": "例如：PO",
      "frequencyPlaceholder": "例如：BID",
      "cancel": "取消",
      "save": "保存"
    },
    "back": "返回",
    "toast": {
      "completed": "用药核对已完成",
      "completeError": "完成核对失败",
      "atLeastOne": "请至少核对一项用药后再完成"
    }
  },
  "components": {
    "dosingCalculator": {
      "title": "剂量计算器",
      "weightLabel": "患者体重 (kg) *",
      "heightLabel": "身高 (cm)",
      "gfrLabel": "GFR/CrCl (mL/min)",
      "weightPlaceholder": "例如 70",
      "heightPlaceholder": "例如 170",
      "gfrPlaceholder": "可选",
      "bsaLabel": "计算的体表面积 (Mosteller):",
      "calculate": "计算剂量",
      "error": "无法计算剂量。后端可能没有该药物的剂量数据。",
      "renalAdjustment": "肾功能调整:",
      "originalDose": "原始剂量:",
      "min": "最小:",
      "max": "最大:",
      "recommended": "推荐: {{dose}} {{unit}}",
      "apply": "应用剂量",
      "method": {
        "weightBased": "基于体重",
        "bsaBased": "基于体表面积",
        "flat": "固定剂量",
        "renalAdjusted": "肾功能调整"
      },
      "unavailable": "Dosing data unavailable for {{name}} — this order isn't linked to a medication catalog entry.",
      "__review_unavailable": "EN placeholder — needs translation"
    }
  },
  "prescribe": {
    "title": "开具药物",
    "submit": "开具处方",
    "navButton": "开处方",
    "noActiveEncounter": "处方必须关联到有效就诊。请先为该患者建立或收治就诊，然后再开具处方。",
    "fields": {
      "medication": "药物",
      "dose": "剂量",
      "doseUnit": "单位",
      "route": "给药途径",
      "frequency": "频次",
      "frequencyDescription": "频次说明",
      "duration": "疗程",
      "durationUnit": "疗程单位",
      "totalDoses": "总剂次",
      "isPrn": "按需（PRN）",
      "prnIndication": "按需指征",
      "administrationInstructions": "给药说明",
      "patientInstructions": "患者须知",
      "quantityDispensed": "配药数量",
      "refillsAuthorized": "可续配次数",
      "allowSubstitution": "允许仿制药替代",
      "pharmacyNotes": "药房备注",
      "indication": "指征",
      "clinicalIndication": "临床指征",
      "priority": "优先级"
    },
    "sections": {
      "drug": "药物",
      "dosing": "剂量",
      "durationPrn": "疗程与按需（PRN）",
      "instructions": "用药说明",
      "dispensing": "配药",
      "clinical": "临床"
    },
    "doseUnitPlaceholder": "如 mg",
    "drugSearch": {
      "placeholder": "搜索处方集…",
      "noResults": "无匹配的处方集药物",
      "clear": "清除选择",
      "catalogRequired": "请从处方集中选择要开具的药物",
      "catalogOnly": "仅可开具处方集内药物，以确保各项安全检查均可执行。",
      "controlledBadge": "管制药品 — 第 {{schedule}} 类",
      "controlledTag": "管制",
      "highAlertBadge": "高警示药品",
      "highAlertTag": "高警示",
      "contraindications": "禁忌症：{{text}}"
    },
    "route": {
      "oral": "口服（PO）",
      "iv": "静脉注射（IV）",
      "subcutaneous": "皮下注射（SC）",
      "intramuscular": "肌肉注射（IM）",
      "topical": "外用",
      "inhalation": "吸入",
      "rectal": "直肠给药（PR）",
      "ophthalmic": "眼用",
      "transdermal": "透皮"
    },
    "frequency": {
      "QD": "每日一次（QD）",
      "BID": "每日两次（BID）",
      "TID": "每日三次（TID）",
      "QID": "每日四次（QID）",
      "Q4H": "每4小时一次（Q4H）",
      "Q6H": "每6小时一次（Q6H）",
      "Q8H": "每8小时一次（Q8H）",
      "Q12H": "每12小时一次（Q12H）",
      "QHS": "睡前（QHS）",
      "PRN": "按需（PRN）",
      "STAT": "立即（STAT）"
    },
    "durationUnit": {
      "days": "天",
      "weeks": "周",
      "months": "月",
      "doses": "剂次"
    },
    "priority": {
      "routine": "常规",
      "asap": "尽快",
      "stat": "立即"
    },
    "validation": {
      "prnIndicationRequired": "按需医嘱必须填写按需指征"
    },
    "contextBar": {
      "ariaLabel": "开方参考信息",
      "allergies": {
        "label": "过敏史",
        "none": "无已知过敏",
        "severe": "严重"
      },
      "weight": {
        "label": "体重",
        "value": "{{weight}} kg",
        "valueWithHeight": "{{weight}} kg · {{height}} cm",
        "notRecorded": "未记录"
      },
      "renal": {
        "label": "肾功能",
        "value": "eGFR {{egfr}} {{unit}}（{{source}}）",
        "unknown": "肾功能未知",
        "source": {
          "reported": "报告值",
          "computed": "计算值",
          "unknown": "未知"
        }
      },
      "pregnancy": {
        "label": "Pregnancy",
        "notRecorded": "Not recorded",
        "recordedOn": "recorded {{date}}",
        "outOfDate": "out of date",
        "lactating": "Lactating"
      }
    },
    "toast": {
      "success": "药物已开具",
      "error": "无法开具此医嘱，请重试。",
      "recordStatusError": "Could not record the pregnancy status"
    },
    "cdsWarnings": {
      "heading": "已开具，附带安全提示",
      "continue": "继续"
    },
    "safetyReview": {
      "title": "需要安全审查",
      "proceed": "覆盖并开具",
      "cancel": "取消",
      "reasonPrompt": "选择覆盖理由…",
      "freeTextLabel": "补充说明",
      "freeTextPlaceholder": "添加临床背景（可选）",
      "hardBlockNote": "此拦截无法覆盖。",
      "cannotOverride": "此处方无法继续——一个或多个拦截无法覆盖。",
      "blockKind": {
        "cds_contraindication": "禁忌",
        "cds_unavailable": "安全筛查不可用",
        "renal_contraindication": "肾功能禁忌",
        "dose_range": "剂量超出推荐范围",
        "pregnancy_contraindication": "妊娠风险",
        "unknown": "其他安全拦截"
      },
      "reasonCodes": {
        "HISTORY_REVIEWED_MANUALLY": "已手动审查病史",
        "NO_KNOWN_RISK_THIS_PATIENT": "该患者无已知风险",
        "URGENT_CLINICAL_NEED": "紧急临床需要",
        "OTHER": "其他（请说明）",
        "BENEFIT_OUTWEIGHS_RISK": "获益大于风险",
        "DOSE_REDUCED_PER_PROTOCOL": "已按方案减量",
        "EGFR_NOT_REPRESENTATIVE": "eGFR不具代表性",
        "SPECIALIST_ADVICE": "专科意见",
        "PATIENT_TOLERANT": "患者可耐受此剂量",
        "SPECIALIST_PROTOCOL": "遵循专科方案",
        "TITRATING_TO_EFFECT": "根据疗效滴定",
        "RANGE_NOT_APPLICABLE": "范围不适用",
        "STATUS_CONFIRMED_NEGATIVE": "已确认未妊娠",
        "BENEFIT_OUTWEIGHS_FETAL_RISK": "获益大于胎儿风险",
        "CONTRACEPTION_CONFIRMED": "已确认有效避孕",
        "PREGNANCY_BEING_TERMINATED": "正在终止妊娠"
      },
      "recordStatus": {
        "heading": "Record the patient's pregnancy status",
        "prompt": "Answering clears this block. Overriding does not answer it.",
        "notPregnant": "Not pregnant",
        "pregnant": "Pregnant",
        "notApplicable": "Not applicable",
        "button": "Record and continue"
      }
    }
  }
}
